import type { ToggleItem } from '@/shared/ui';
import type { Filter } from '../model/station.types';

export const TOGGLE_OPTION: ReadonlyArray<ToggleItem<Filter>> = [
	{ label: '절약순', value: 'savings' },
	{ label: '거리순', value: 'distance' },
	{ label: '최저가순', value: 'price' },
] as const;
